const BackIcon = () => {
	return (
		<svg
			width='10'
			height='18'
			viewBox='0 0 10 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M0 8.68756C0 9.03036 0.127326 9.32419 0.401567 9.57884L8.02155 17.0421C8.23702 17.2576 8.51126 17.3751 8.83448 17.3751C9.4809 17.3751 10 16.8658 10 16.2096C10 15.8864 9.86288 15.6023 9.6474 15.3771L2.78159 8.68756L9.6474 1.99804C9.86288 1.77277 10 1.47894 10 1.16552C10 0.509305 9.4809 0 8.83448 0C8.51126 0 8.23702 0.117532 8.02155 0.333007L0.401567 7.78648C0.127326 8.05093 0 8.34476 0 8.68756Z'
				fill='#1C1C1E'
			/>
		</svg>
	);
};

export default BackIcon;
